module.exports = __webpack_public_path__ + "static/media/frighteningPotential.80ca07ce.png";